import { trackInteraction } from '../analytics';
import { varsFromServer } from '../client_side_injection_vars';

export function trackSliderInteraction(sliderName, sliderImageIndex, sliderAction) {
  const props = {
    label: sliderName,
    sliderImageIndex,
    sliderAction
  };

  if (varsFromServer.building) {
    props.hasVirtualTour = varsFromServer.building.has_virtual_tour;
  }

  trackInteraction(props);
}
